import styled from 'styled-components';

export const StorytellerSearchWrapper = styled.div`
	width: 100%;
	display: flex;
	gap: ${({ theme }) => theme.spacing.xs};
	align-items: center;
`;
